import type { RSISettings } from "../../model";
import { COLORS, GRID } from "features/chart";

const TOP = 8;
const BOTTOM = 20;

export function drawRSI(
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
  values: (number | null)[],
  visibleStart: number,
  visibleEnd: number,
  settings: RSISettings,
): void {
  const { left, right } = GRID;
  const chartW = width - left - right;
  const chartH = height - TOP - BOTTOM;

  ctx.fillStyle = COLORS.bg;
  ctx.fillRect(0, 0, width, height);

  const startIdx = Math.floor(visibleStart);
  const endIdx = Math.ceil(visibleEnd);
  const cw = chartW / (Math.floor(visibleEnd) - startIdx + 1);

  const valToY = (v: number) => TOP + ((100 - v) / 100) * chartH;

  ctx.font = "10px sans-serif";
  const lineEndX = width - right - ctx.measureText("100").width - 6;

  ctx.strokeStyle = COLORS.grid;
  ctx.lineWidth = 1;
  for (let i = 0; i <= 2; i++) {
    const y = TOP + (chartH * i) / 2;
    ctx.beginPath();
    ctx.moveTo(left, y);
    ctx.lineTo(lineEndX, y);
    ctx.stroke();
  }

  for (const level of [settings.level1, settings.level2, settings.level3]) {
    if (!level.visible) continue;
    const y = valToY(level.value);
    ctx.strokeStyle = level.color;
    ctx.lineWidth = level.width;
    ctx.beginPath();
    ctx.moveTo(left, y);
    ctx.lineTo(lineEndX, y);
    ctx.stroke();
  }

  if (settings.mainLine.visible) {
    ctx.strokeStyle = settings.mainLine.color;
    ctx.lineWidth = settings.mainLine.width;
    ctx.beginPath();
    let started = false;
    for (let i = startIdx; i <= endIdx; i++) {
      const v = values[i];
      if (v === null || v === undefined) { started = false; continue; }
      const x = left + (i - startIdx + 0.5) * cw;
      const y = valToY(v);
      if (!started) { ctx.moveTo(x, y); started = true; }
      else ctx.lineTo(x, y);
    }
    ctx.stroke();
  }

  ctx.fillStyle = COLORS.label;
  ctx.textAlign = "right";
  ctx.textBaseline = "middle";
  const labelX = width - right + 2;
  for (const level of [settings.level1, settings.level2, settings.level3]) {
    if (!level.visible) continue;
    ctx.fillText(String(level.value), labelX, valToY(level.value));
  }
}
